import React from "react";

// Official RYCM pennant flag — red field with yellow cross + YCM monogram + crown (transparent PNG)
const LOGO_URL = "/rycm-logo.png";

export default function Logo({ size = "md", invert = false, withText = true }) {
  const dims = {
    sm: { img: "h-8 w-auto", title: "text-base", sub: "text-[9px]" },
    md: { img: "h-10 w-auto", title: "text-lg", sub: "text-[10px]" },
    lg: { img: "h-14 w-auto", title: "text-2xl", sub: "text-[11px]" },
  }[size] || { img: "h-10 w-auto", title: "text-lg", sub: "text-[10px]" };

  return (
    <div className="flex items-center gap-3" data-testid="rycm-logo">
      <img
        src={LOGO_URL}
        alt="RYCM pennant"
        className={`${dims.img} object-contain shrink-0`}
        loading="eager"
      />
      {withText && (
        <div className="leading-tight">
          <div className={`font-serif ${dims.title} ${invert ? "text-white" : "text-navy"}`}>RYCM</div>
          <div className={`${dims.sub} tracking-[0.25em] uppercase ${invert ? "text-club-yellow" : "text-club-red"} font-medium`}>
            Royal Yacht Club · Meuse
          </div>
        </div>
      )}
    </div>
  );
}
